import {Project} from "./Project";
import {ProjectRelation} from "./ProjectRelation";
import {Contact} from "./Contact";
import {ProjectSettings} from "./ProjectSettings";
import {RelationNote} from "./RelationNote";
import {ProjectNote} from "./ProjectNote";

export const customerRelationTypeOptions = {
  'business-small': 'Zakelijk',
  'business-large': 'Groot zakelijk',
  'individual': 'Particulier',
}

export type CustomerRelationType = keyof typeof customerRelationTypeOptions;

export class Relation {
  constructor(
    public readonly id: string,
    public readonly proteusId: string,
    public readonly name: string,
    public readonly type: CustomerRelationType | null,
    public readonly alias: string,
    public readonly status: string,
    public readonly phone: string,
    public readonly locationAddressStreetname: string,
    public readonly locationAddressHouseNumber: string|null,
    public readonly locationAddressHouseNumberAddition: string|null,
    public readonly locationCity: string,
    public readonly locationZipcode: string,
    public readonly mailingAddressStreetname: string|null,
    public readonly mailingAddressHouseNumber: string|null,
    public readonly mailingAddressHouseNumberAddition: string|null,
    public readonly mailingCity: string,
    public readonly mailingZipcode: string,
    public readonly web: string|null,
    public readonly email: string,
    public readonly paymentTerm: number|null,
    public readonly vatRateId: string|null,
    public readonly cocNumber: string|null,
    public readonly vatNumber: string|null,
    public readonly iban: string|null,
    public readonly isSupplier: boolean,
    public readonly supplierDefaultLedgerAccountId: string|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly projects: Project[]|null,
    public readonly projectRelations: ProjectRelation[]|null,
    public readonly contacts: Contact[]|null,
    public readonly relationNotes: RelationNote[]|null,
    public readonly projectSettings?: ProjectSettings|null,
  ) {
  }

  static fromJson(json: any): Relation {
    return new Relation(
      json['id'],
      json['proteus_id'],
      json['name'],
      json['type'],
      json['alias'],
      json['status'],
      json['phone'],
      json['location_address_streetname'],
      json['location_address_house_number'],
      json['location_address_house_number_addition'],
      json['location_city'],
      json['location_zipcode'],
      json['mailing_address_streetname'],
      json['mailing_address_house_number'],
      json['mailing_address_house_number_addition'],
      json['mailing_city'],
      json['mailing_zipcode'],
      json['web'],
      json['email'],
      json['payment_term'],
      json['vat_rate_id'],
      json['coc_number'],
      json['vat_number'],
      json['iban'],
      json['is_supplier'] ?? false,
      json['supplier_default_ledger_account_id'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['projects'] ? json['projects'].map((p: any) => Project.fromJson(p)) : null,
      json['project_relations'] ? json['project_relations'].map((po: any) => ProjectRelation.fromJson(po)) : null,
      json['contacts'] ? json['contacts'].map((c: any) => Contact.fromJson(c)) : null,
      json['relation_notes'] ? json['relation_notes'].map((rn: any) => RelationNote.fromJson(rn)) : null,
      json['project_settings'] ? ProjectSettings.fromJson(json['project_settings']) : null,
    )
  }
}